import React from 'react';
import PropTypes from 'prop-types';

import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';

import Icon from '../ui/elements/Icon';
import InputAutocomplete from '../ui/form/InputAutocomplete';
import { YMaps, Map } from "react-yandex-maps";

class CreateOrderForm extends React.Component {
  constructor(props) {
    super(props);

    const selectedWays = this.props.deliveryWays.filter((e) => {
      return (e.id == this.props.selectedDeliveryWay);
    });
    let sum = 0; //data.deliveryWays[0].id;
    let way_name = ''
    if (selectedWays.length > 0) {
      sum = selectedWays[0].sum;
      way_name = selectedWays[0].name;
    }

    this.state = {
      branch: this.props.selectedBranch || this.props.branches[0].id,
      deliveryWays: this.props.deliveryWays,
      dealerFord: this.props.dealerFord,
      warrantyEmployee: this.props.warrantyEmployee,
      hasUnavailableFordParts: this.props.hasUnavailableFordParts || false,
      deliveryWay: this.props.selectedDeliveryWay || '', //this.props.deliveryWays[0].id,
      paymentType: this.props.paymentTypes[0][0],
      fragile: this.props.fragile || false,
      ford_owner_customer_inn: '',
      ford_owner_customer_name: '',
      ford_owner_car_vin: '',
      ford_work_order: '',
      isWarranty: this.props.forWarranty,
      isBodywork: false,
      lathing: undefined,
      vin: '',
      submiting: false,
      orderSum: this.props.orderSum,
      minSum: sum || 0,
      selectedDeliveryWayName: way_name
    };

    this.handleChangeBranch = this.handleChangeBranch.bind(this);
    this.handleChangeAddress = this.handleChangeAddress.bind(this);
    this.handleChangeVin = this.handleChangeVin.bind(this);
    this.handleChangeDealer = this.handleChangeDealer.bind(this);
    this.handleChangeDeliveryWay = this.handleChangeDeliveryWay.bind(this);
    this.handleChangePaymentType = this.handleChangePaymentType.bind(this);
    this.handleChangeLathing = this.handleChangeLathing.bind(this);
    this.handleChangeFordOwnerName = this.handleChangeFordOwnerName.bind(this);
    this.handleChangeFordOwnerInn = this.handleChangeFordOwnerInn.bind(this);
    this.handleChangeFordOwnerCarVin = this.handleChangeFordOwnerCarVin.bind(this);
    this.handleChangeIsWarranty = this.handleChangeIsWarranty.bind(this);
    this.handleChangeIsBodywork = this.handleChangeIsBodywork.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleMove = this.handleMove.bind(this);
    this.changeForClientInput = this.changeForClientInput.bind(this);

    this.pickUpId = 34;
  }

  changeForClientInput(event) {
    const target = event.target;
    this.setState((state) => ({
      for_client_condition: target.checked
    }));
  }

  handleChangeBranch(event) {
    this.setState({ branch: event.target.value }, () => {
      fetch(`/branches/${this.state.branch}.json`, { credentials: 'same-origin' })
        .then(function (response) {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
          }
        })
        .then((data) => {
          // this.setState({ deliveryWay: data.deliveryWays[0].id, deliveryWays: data.deliveryWays });
          const branch = this.state.branch;
          const branchFromPreferences = this.props.deliveryPreferences.filter((e) => {
            return (e.branchId == branch);
          });
          let way = ''; //data.deliveryWays[0].id;
          if (branchFromPreferences.length > 0) {
            way = branchFromPreferences[0];
            this.setState({ minSum: (way.minimalSum || 0), deliveryWay: way.deliveryWay.id, selectedDeliveryWayName: way.deliveryWay.name, deliveryWays: data.deliveryWays });
          } else {
            this.setState({ minSum: 0, deliveryWay: way, selectedDeliveryWayName: '', deliveryWays: data.deliveryWays });
          }

        })
        .catch((error) => {
          this.setState({ isUpdating: false });
          alert('Произошла ошибка при попытке получить способы доставки выбранного склада отгрузки');
        });
    });
  }

  handleChangeDeliveryWay(event) {
    if (document.getElementById("order_address_id")) {
      document.getElementById("order_address_id").selectedIndex = 0;;
      document.getElementById("address_text").innerHTML = '';
    }
    if (event.target.options[event.target.selectedIndex].dataset.sum) {
      this.setState({ minSum: parseInt(event.target.options[event.target.selectedIndex].dataset.sum) });
    } else {
      this.setState({ minSum: 0 });
    }
    this.setState({ deliveryWay: event.target.value, selectedDeliveryWayName: event.target.options[event.target.selectedIndex].text });
  }

  handleChangePaymentType(event) {
    this.setState({ paymentType: event.target.value });
  }

  handleChangeLathing(event) {
    this.setState({ lathing: event.target.value });
  }

  handleChangeFordOwnerName(event) {
    this.setState({ ford_owner_customer_name: event.target.value });
  }

  handleChangeFordOwnerInn(event) {
    this.setState({ ford_owner_customer_inn: event.target.value });
  }

  handleChangeFordOwnerCarVin(item) {
    this.setState({ ford_owner_car_vin: item.vin });
  }

  handleChangeFordWorkOrder(event) {
    this.setState({ ford_work_order: event.target.value });
  }

  handleChangeIsBodywork(event) {
    this.setState({ isBodywork: event.target.checked });
  }

  handleChangeVin(item) {
    this.setState({ vin: item.vin });
  }

  handleChangeDealer(event) {
    this.setState({ dealer: event.target.value });
  }

  handleChangeAddress(event) {
    if (this.state.selectedDeliveryWayName == "Доставка до двери"){
      if (event.target.options[event.target.selectedIndex].dataset.text) {
        let free = event.target.options[event.target.selectedIndex].dataset.sum;
        if (free && parseInt(free) > this.state.orderSum) {
          document.getElementById("address_text").innerHTML = `
        <p>${event.target.options[event.target.selectedIndex].dataset.text}</p>
        <p>Обратите внимание! ${event.target.options[event.target.selectedIndex].dataset.free}</p>
        `
        } else if (free && parseInt(free) <= this.state.orderSum) {
          document.getElementById("address_text").innerHTML = `
        <p>${event.target.options[event.target.selectedIndex].dataset.free}</p>
        `
        } else {
          document.getElementById("address_text").innerHTML = `<p>${event.target.options[event.target.selectedIndex].dataset.text}</p>`
        }
      } else {
        document.getElementById("address_text").innerHTML = "Ваш персональный менеджер свяжется с Вами и рассчитает стоимость доставки на новый адрес";
      }
    } else {
      if (event.target.options[event.target.selectedIndex].dataset.turbotext) {
        let free = event.target.options[event.target.selectedIndex].dataset.turbosum;
        if (free && parseInt(free) > this.state.orderSum) {
          document.getElementById("address_text").innerHTML = `
        <p>${event.target.options[event.target.selectedIndex].dataset.turbotext}</p>
        <p>Обратите внимание! ${event.target.options[event.target.selectedIndex].dataset.turbofree}</p>
        `
        } else if (free && parseInt(free) <= this.state.orderSum) {
          document.getElementById("address_text").innerHTML = `
        <p>${event.target.options[event.target.selectedIndex].dataset.turbofree}</p>
        `
        } else {
          document.getElementById("address_text").innerHTML = `<p>${event.target.options[event.target.selectedIndex].dataset.turbotext}</p>`
        }
      } else {
        document.getElementById("address_text").innerHTML = "Ваш персональный менеджер свяжется с Вами и рассчитает стоимость доставки";
      }
    }
    if (event.target.value == "new") {
      document.getElementById("order_text_address").closest('.field').classList.remove("is-hidden");
    } else {
      document.getElementById("order_text_address").closest('.field').classList.add("is-hidden");
    }
    this.setState({ address: event.target.value });
  }

  handleChangeIsWarranty(event) {
    this.setState({ isWarranty: event.target.checked }, () => {
      fetch(`/cart_items/set_warranty.json?value=${this.state.isWarranty}`, {
        credentials: 'same-origin',
        headers: { 'X-CSRF-Token': Rails.csrfToken() },
        method: 'PATCH'
      })
        .then(function (response) {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
          }
        })
        .then((response) => {
          if (response["need_update"] == "true") {
            this.props.onChange();
            alert('Вы изменили маркер гарантии. Цена на некоторые товары могла измениться.');
          }

        })
        .catch((error) => {
          this.setState({ isUpdating: false });
          alert('При попытке установить маркер гарантии произошла ошибка.');
        });
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.isSubmiting) {
      return;
    }

    this.setState({ isSubmiting: true }, () => {
      const data = new FormData(document.forms.createOrder);
      fetch('/orders.json', {
        body: data,
        credentials: 'same-origin',
        headers: { 'X-CSRF-Token': Rails.csrfToken() },
        method: 'POST',
      })
        .then(function (response) {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
          }
        })
        .then((data) => {
          if (window.ym) {
            ym(110754326, 'reachGoal', 'oformitzakaz');
          }

          window.dataLayer.push({
            ecommerce: {
              currencyCode: 'RUB',
              purchase: {
                actionField: {
                  id: data.number,
                  goal_id: '38016605',
                },
                products: data.orderParts.map((orderPart) => ({
                  brand: orderPart.part.brand.name,
                  id: orderPart.part.article,
                  name: [orderPart.part.brand.name, orderPart.part.article, orderPart.part.description].join(' '),
                  price: orderPart.price,
                  quantity: orderPart.quantity,
                })),
              },
            },
          });

          Turbolinks.visit(`/orders?notice=${encodeURIComponent('Ваш заказ передан в обработку')}`);
        })
        .catch((error) => {
          console.log(error);
          this.setState({ isSubmiting: false });
          alert('Произошла ошибка при попытке оформить заказ');
        });
    });
  }

  handleMove(event) {
    event.preventDefault();
    if (this.state.isSubmiting) {
      return;
    }

    this.setState({ isSubmiting: true }, () => {
      const data = new FormData(document.forms.createOrder);
      fetch('/orders/movement.json', {
        body: data,
        credentials: 'same-origin',
        headers: { 'X-CSRF-Token': Rails.csrfToken() },
        method: 'POST',
      })
        .then(function (response) {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
          }
        })
        .then((data) => {
          Turbolinks.visit(`/?notice=${encodeURIComponent('Товар будет направлен в филиал')}`);
        })
        .catch((error) => {
          console.log(error);
          this.setState({ isSubmiting: false });
          alert('Произошла ошибка при попытке сформировать заказ');
        });
    });
  }

  get readyToSubmit() {
    return ((!this.props.fragile || this.state.lathing !== undefined || !this.displayLathingField)
      && this.state.deliveryWay !== ''
      && (this.props.dealerFord || this.state.orderSum >= this.state.minSum)
      && (!this.props.warrantyEmployee || (this.props.warrantyEmployee && this.state.vin !== '' && this.state.dealer !== undefined))
      &&
      (!this.state.isWarranty || (this.state.isWarranty &&
        this.state.ford_owner_customer_name !== '' && this.state.ford_owner_car_vin !== ''))
      &&
      (!this.state.isBodywork || (this.state.isBodywork &&
        this.state.ford_owner_customer_name !== '' && this.state.ford_owner_car_vin !== ''))
      && !this.props.needCompensation
    );
  }

  get displayLathingField() {
    return parseInt(this.state.deliveryWay) !== this.pickUpId;
  }

  render() {
    const cartItems = this.props.cartItems.map((cartItem) => (
      <input type="hidden" key={cartItem.id} name={this.props.recommended ? 'order[recommended_cart_item_ids][]' : 'order[cart_item_ids][]'} value={cartItem.id} />
    ));

    const branches = this.props.branches.map((branch) => {
      return (
        <option key={branch.id} value={branch.id}>
          {branch.name}
        </option>
      );
    });

    const companies = this.props.companies.map((company) => {
      return (
        <option key={company.id} value={company.id}>
          {company.name}
        </option>
      );
    });

    const dealers = this.props.dealers.map((dealer) => {
      return (
        <option key={dealer.id} value={dealer.id}>
          {dealer.name}
        </option>
      );
    });

    const addresses = this.props.addresses.filter((address) => address.branchId == this.state.branch).map((address) => {
      return (
        <option key={address.id} value={address.id} data-text={address.deliveryText} data-free={address.freeDeliveryText} data-sum={address.freeSum}
                data-turbotext={address.turboDeliveryText} data-turbofree={address.turboFreeDeliveryText} data-turbosum={address.turboFreeSum}>
          {address.superscription}
        </option>
      );
    });

    const deliveryWays = this.state.deliveryWays.map((deliveryWay) => {
      return (
        <option key={deliveryWay.id} value={deliveryWay.id} data-sum={deliveryWay.sum}>
          {deliveryWay.name}
        </option>
      );
    });

    const paymentTypes = this.props.paymentTypes.map((paymentType) => {
      return (
        <option key={paymentType[0]} value={paymentType[0]}>
          {paymentType[1]}
        </option>
      );
    });

    const loadSuggest = ymaps => {
      const suggestView = new ymaps.SuggestView("order_text_address");
      // suggestView.events.add('select', function (e) {
      //   console.log(e.get('item'));
      //   alert(e.get('item').displayName);
      //   const displayName = e.get('item').displayName
      //   let myGeocoder = ymaps.geocode(displayName);
      //   myGeocoder.then(
      //     async function (res) {
      //       const coords = await res.geoObjects.get(0).geometry._coordinates;
      //       console.log(coords)
      //     }
      //   )
      // });
    };

    return (
      <form name="createOrder" onSubmit={this.readyToSubmit ? this.handleSubmit : ''}>
        {cartItems}

        {this.props.canBuyForClient && (
          <div>
            <div className="field">
              <div className="control">
                <label className="checkbox">
                  <input
                    name="for_client"
                    type="checkbox"
                    value="1"
                    checked={this.state.for_client_condition}
                    onChange={this.changeForClientInput}
                  />{' '}
                  ЗАКАЗ ОФОРМЛЯЕТСЯ НА КЛИЕНТА
                </label>
              </div>
            </div>
            <div className="field" style={this.state.for_client_condition ? { display: 'block' } : { display: 'none' }}>
              <div className="control">
                <div className="select is-medium">
                  <select name="order[company_id]" disabled={!this.state.for_client_condition} onChange={this.handleChangeCompany}>
                    <option>
                      Выберите клиента из списка
                    </option>
                    {companies}
                  </select>
                </div>
              </div>
              <br></br>
            </div>
          </div>
        )}

        <div className="field is-horizontal">
          <div className="field-body">
            <div className="field is-narrow">
              <label className="label">Склад отгрузки</label>
              <div className="control">
                <div className="select">
                  <select name="order[branch_id]" value={this.state.branch} onChange={this.handleChangeBranch}>
                    {branches}
                  </select>
                </div>
              </div>
            </div>
            <div className="field is-narrow">
              <label className="label">Способ доставки</label>
              <div className="control">
                <div className={this.state.deliveryWay == '' ? 'select is-danger' : 'select'}>
                  <select
                    name="order[delivery_way_id]"
                    id="order_delivery_way_id"
                    value={this.state.deliveryWay}
                    onChange={this.handleChangeDeliveryWay}
                  >
                    <option key="0" value=''>
                      Выберите способ доставки
                    </option>
                    {deliveryWays}
                  </select>
                </div>
              </div>
            </div>
            {this.props.canPayOnline && (
              <div className="field is-narrow">
                <label className="label">
                  Способ оплаты
                  <span className="has-text-danger">*</span>
                </label>
                <div className="control">
                  <div className="select">
                    <select
                      name="order[payment_type]"
                      value={this.state.paymentType}
                      onChange={this.handleChangePaymentType}
                    >
                      {paymentTypes}
                    </select>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/*{this.state.selectedDeliveryWayName == "Доставка до двери" && this.state.branch == 1 && (*/}
        {/*  <div>*/}
        {/*    <p className="has-text-success-dark">Обратите внимание! Мы доставим Ваш заказ на любую сумму, размещенный с 9:00 до 17:00, курьерской службой Яндекс Доставка или Dostavista сегодня. Для этого выберите способ доставки <strong>"Турбо-доставка"</strong></p>*/}
        {/*    <br></br>*/}
        {/*  </div>*/}
        {/*)}*/}

        {this.props.fragile && this.displayLathingField && (
          <div className="field is-size-5">
            <label className="label is-size-5">Внимание, хрупкий товар!</label>
            <div className="media">
              <div className="media-left is-vertically-middle has-text-centered">
                <Icon icon="wine-glass" size="large" />
              </div>
              <div className="media-content">
                <p>
                  В заказе присутствует хрупкий товар. Предлагаем воспользоваться услугой «обрешётка», предоставляемой
                  транспортными компаниями. Услуга платная.
                </p>
                <div className="control">
                  <label className="radio is-size-4 has-text-weight-bold">
                    <input
                      name="order[lathing]"
                      type="radio"
                      value="need_lathing"
                      onChange={this.handleChangeLathing}
                    />{' '}
                    отправить с обрешёткой
                  </label>
                  <label className="radio is-size-4 has-text-weight-bold">
                    <input
                      name="order[lathing]"
                      type="radio"
                      value="refused_lathing"
                      onChange={this.handleChangeLathing}
                    />{' '}
                    отправить без обрешётки
                  </label>
                </div>
                {this.state.lathing === undefined && (
                  <p className="help is-danger has-text-weight-bold is-size-5">
                    Выберите, пожалуйста, один из вариантов отправки груза.
                  </p>
                )}
              </div>
            </div>
          </div>
        )}

        {!this.props.fragile && this.displayLathingField && (
          <div className="field">
            <div className="control">
              <label className="checkbox is-size-5 has-text-weight-bold">
                <input
                  name="order[lathing]"
                  type="checkbox"
                  value="need_lathing"
                  onChange={this.handleChangeLathing}
                />{' '}
                отправить с обрешёткой
              </label>
            </div>
          </div>
          )
        }


        {this.props.dealerFord && (
          <div id="for_dealer">
            <br></br>
            <div className="columns">
              <div className="column is-narrow">
                <div className="field">
                  <div className="control">
                    <p style={{ height: '10px' }}></p>
                    <label className="checkbox is-size-5">
                      <input
                        name="order[is_warranty]"
                        type="checkbox"
                        value="1"
                        checked={this.state.isWarranty}
                        onChange={this.handleChangeIsWarranty}
                      />{' '}
                      <strong>ГАРАНТИЯ</strong>
                    </label>
                  </div>
                </div>

                <div className="field">
                  <div className="control">
                    <label className="checkbox is-size-5">
                      <input
                        name="order[is_bodywork]"
                        type="checkbox"
                        value="1"
                        checked={this.state.isBodywork}
                        onChange={this.handleChangeIsBodywork}
                      />{' '}
                      <strong>КУЗОВНОЙ</strong>
                    </label>
                  </div>
                </div>
              </div>
              <div className="column">
                <div className="field">
                  <label className="label">Заказчик владелец а/м FORD</label>
                  <div className="control">
                    {/* {this.state.ford_owner_customer_name == '' && this.state.ford_owner_customer_inn == '' ? 'input is-danger' : 'input'} */}
                    <input
                      className={(this.state.isWarranty || this.state.isBodywork) && this.state.ford_owner_customer_name == '' ? 'input is-danger' : 'input'}
                      name="order[ford_owner_customer_name]"
                      onChange={this.handleChangeFordOwnerName}
                    />
                  </div>
                </div>
              </div>
              {/* <div className="column">
                <div className="field">
                  <label className="label">Идентификационный номер (VIN) автомобиля, Турция</label>
                  <div className="control">
                    <input
                      className={this.state.isWarranty && this.state.ford_owner_car_vin == '' ? 'input is-danger' : 'input'}
                      maxLength={17}
                      name="order[ford_owner_car_vin]"
                      onChange={this.handleChangeFordOwnerCarVin}
                    />
                  </div>
                </div>
              </div>*/}
              <div className="column">
                <div className="field">
                  <label className="label">Идентификационный номер (VIN) автомобиля, Турция</label>
                  <div className="control">
                    <input
                      type="hidden"
                      name="order[ford_owner_car_vin]]"
                      defaultValue={this.state.ford_owner_car_vin}
                    />
                    <InputAutocomplete
                      item={{ vin: this.state.ford_owner_car_vin }}
                      itemDecorator={(item) => {
                        return (
                          <React.Fragment>
                            {item.vin}
                          </React.Fragment>
                        );
                      }}
                      classes={(this.state.isWarranty || this.state.isBodywork) && this.state.ford_owner_car_vin == '' ? 'is-danger' : ''}
                      onChange={this.handleChangeFordOwnerCarVin}
                      textDecorator={(item) => item && item.vin}
                      url="/vins.json"
                    />
                  </div>
                </div>
              </div>
              <div className="column">
                <div className="field">
                  <label className="label">Заказ-наряд</label>
                  <div className="control">
                    {/* {this.state.ford_owner_customer_name == '' && this.state.ford_owner_customer_inn == '' ? 'input is-danger' : 'input'} */}
                    <input
                      className="input"
                      name="order[ford_work_order]"
                      onChange={this.handleChangeFordWorkOrder}
                    />
                  </div>
                </div>
              </div>
            </div>
            <br></br>
          </div>
        )}

        {this.props.warrantyEmployee && (
          <div id="for_warranty_employee">
            <br></br>
            <div className="columns">
              <div className="column is-narrow">
                <div className="field">
                  <label className="label">Дилер</label>
                  <div className="control">
                    <div className={this.state.dealer == undefined ? 'is-danger select' : 'select'}>
                      <select name="order[dealer_id]" onChange={this.handleChangeDealer}>
                        <option>
                          Выберите дилера из списка
                        </option>
                        {dealers}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="column">
                <div className="field">
                  <label className="label">Идентификационный номер (VIN) автомобиля, Турция</label>
                  <div className="control">
                    <input
                      type="hidden"
                      name="order[vin]"
                      defaultValue={this.state.vin}
                    />
                    <InputAutocomplete
                      item={{ vin: this.state.vin }}
                      itemDecorator={(item) => {
                        return (
                          <React.Fragment>
                            {item.vin}
                          </React.Fragment>
                        );
                      }}
                      classes={this.state.vin == '' ? 'is-danger' : ''}
                      onChange={this.handleChangeVin}
                      textDecorator={(item) => item && item.vin}
                      url="/vins.json"
                    />
                  </div>
                </div>
              </div>
            </div>
            <br></br>
          </div>
        )}

        {(this.state.selectedDeliveryWayName == "Доставка до двери" || this.state.selectedDeliveryWayName == "Турбо-доставка") && this.props.addresses.length > 0 && (
          <div className="field">
            <label className="label">Адрес доставки</label>
            <div className="control">
              <div className='select'>
                <select id="order_address_id" name="order[address_id]" onChange={this.handleChangeAddress}>
                  <option>
                    Выберите адрес из списка
                  </option>
                  {addresses}
                  <option value="new">
                    Новый адрес
                  </option>
                </select>
              </div>
            </div>
            <p className="help" id="address_text"></p>
          </div>
        )}

        <div className="field is-hidden">
          <div className="control">
            <input placeholder="Ваш адрес..." id="order_text_address" className="input" name="order[text_address]" />
          </div>
          <YMaps>
            <Map
              onLoad={ymaps => loadSuggest(ymaps)}
              defaultState={{ center: [55.751574, 37.573856], zoom: 9 }}
              modules={["SuggestView"]}
              style={{"display" : "none"}}
            />
          </YMaps>
        </div>

        <div className="field">
          <label className="label">Комментарий к заказу</label>
          <div className="control">
            <textarea className="textarea" name="order[comment]" />
          </div>
        </div>

        {this.props.employee && (
          <div className="field">
            <label className="checkbox">
              <input name="order[movement]" type="checkbox" value="1" defaultChecked={true} />{' '}
              Перемещение
            </label>
          </div>
        )}

        { this.props.needInfo && (
        <div data-controller="shared--modal">
          <a id="modal_cart_button"
             className={`button is-primary ${this.state.isSubmiting ? 'is-loading' : ''}`}
             disabled={!this.readyToSubmit || this.state.isSubmiting}
             data-action={this.readyToSubmit ? 'click->shared--modal#open' : ''} title="Купить">
            Оформить заказ
          </a>
          {!this.props.dealerFord && this.state.orderSum < this.state.minSum && this.state.selectedDeliveryWayName != '' && (
            <span className="help has-text-danger">
                <i>Сумма заказа с выбранным способом доставки - {this.state.selectedDeliveryWayName} - не может быть менее {this.state.minSum} рублей. Увеличьте, пожалуйста, сумму вашего заказа.</i>
              </span>
          )}
          {this.props.needCompensation && (
            <span className="help has-text-primary">
                <i className="is-size-5">Для оформления заказа на новую деталь <a className="is-underlined" href="https://turbotrucks.ru/compensations/new">подайте заявку</a> на компенсацию по старой детали.</i>
              </span>
          )}
          {this.state.isSubmiting && (
            <span className="has-inline-text">
                <i>Не закрывайте, пожалуйста, страницу, ваш заказ обрабатывается...</i>
              </span>
          )}

          <div data-target="shared--modal.modal" className="modal callback__modal">
            <div className="modal-background" data-action="click->shared--modal#close"></div>
            <div className="modal-card">
              <header className="modal-card-head">

              </header>
              <section className="modal-card-body">
                <p className="is-size-5">Уважаемый клиент, в связи с инвентаризацией склада, Ваш заказ будет отгружен 9 января.</p>
              </section>
              <footer className="modal-card-foot">
                <a
                  className={`button is-primary ${this.state.isSubmiting ? 'is-loading' : ''}`}
                  disabled={!this.readyToSubmit || this.state.isSubmiting}
                  onClick={this.readyToSubmit ? this.handleSubmit : ''}
                >
                  Подтвердить
                </a>
                <button type="button" className="button is-text"
                        data-action="click->shared--modal#close">отмена</button>
              </footer>
            </div>
          </div>
        </div>
        )}

        { !this.props.needInfo && (
        <div>
          <div className="field is-grouped">
            <div className="control">
              <a
                className={`button is-primary ${this.state.isSubmiting ? 'is-loading' : ''}`}
                disabled={!this.readyToSubmit || this.state.isSubmiting}
                onClick={this.readyToSubmit ? this.handleSubmit : ''}
              >
                Оформить заказ
              </a>
            </div>
            { this.props.canSendToBranch &&
              <div className="control">
                <a
                  className={`button is-warning ${this.state.isSubmiting ? 'is-loading' : ''}`}
                  disabled={!this.readyToSubmit || this.state.isSubmiting}
                  onClick={this.readyToSubmit ? this.handleMove : ''}
                >
                  Отправить товар в филиал
                </a>
              </div>
            }

          </div>

          {!this.props.dealerFord && this.state.orderSum < this.state.minSum && this.state.selectedDeliveryWayName != '' && (
            <span className="help has-text-danger">
              <i>Сумма заказа с выбранным способом доставки - {this.state.selectedDeliveryWayName} - не может быть менее {this.state.minSum} рублей. Увеличьте, пожалуйста, сумму вашего заказа.</i>
            </span>
          )}
          {this.props.needCompensation && (
            <span className="help has-text-primary">
              <i className="is-size-5">Для оформления заказа на новую деталь <a className="is-underlined" href="https://turbotrucks.ru/compensations/new">подайте заявку</a> на компенсацию по старой детали.</i>
            </span>
          )}
          {this.state.isSubmiting && (
            <span className="has-inline-text">
              <i>Не закрывайте, пожалуйста, страницу, ваш заказ обрабатывается...</i>
            </span>
          )}
        </div>
        )}
      </form>
    );
  }
}

CreateOrderForm.propTypes = {
  branches: PropTypes.arrayOf(PropTypes.object),
  companies: PropTypes.arrayOf(PropTypes.object),
  dealers: PropTypes.arrayOf(PropTypes.object),
  cartItems: PropTypes.arrayOf(PropTypes.object),
  deliveryWays: PropTypes.arrayOf(PropTypes.object),
  addresses: PropTypes.arrayOf(PropTypes.object),
  paymentTypes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  deliveryPreferences: PropTypes.arrayOf(PropTypes.object),
  fragile: PropTypes.bool.isRequired,
  selectedBranch: PropTypes.number,
  selectedDeliveryWay: PropTypes.number,
  employee: PropTypes.bool,
  canBuyForClient: PropTypes.bool,
  dealerFord: PropTypes.bool,
  warrantyEmployee: PropTypes.bool,
  canPayOnline: PropTypes.bool,
  canSendToBranch: PropTypes.bool,
  onChange: PropTypes.func,
  hasUnavailableFordParts: PropTypes.bool,
  recommended: PropTypes.bool,
  needCompensation: PropTypes.bool,
  needInfo: PropTypes.bool
};

export default CreateOrderForm;
